import { render, staticRenderFns } from "./SpecimenChickenAlivesDetail.vue?vue&type=template&id=21230648"
import script from "./SpecimenChickenAlivesDetail.vue?vue&type=script&lang=js"
export * from "./SpecimenChickenAlivesDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecimenChickenAlivesDetail.vue?vue&type=style&index=0&id=21230648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports